<template>
  <div>
    <vue-header />
    <div class="wd-container" style="margin-top: 15px; text-align: left;">
      <div class="container">
        <loading :active.sync="isLoading" :can-cancel="false" :width="50" :height="50" :is-full-page="false" />
        <b-card no-body>
          <b-card-text class="p-3">
            <h5 class="mb-3">Skills by Group</h5>
            <div v-if="skillGroups.length === 0" class="text-muted">No skill groups available.</div>

            <div v-for="group in skillGroups" :key="group.employee_skill_type_id" class="mb-3 border rounded">
              <div class="d-flex align-items-center justify-content-between p-2" style="background: #f6f7f9; cursor: pointer;" @click="toggleSkillGroup(group.employee_skill_type_id)">
                <div>
                  <strong>{{ expandedSkillGroups[group.employee_skill_type_id] ? '▼' : '▶' }} {{ resolveSkillGroupLabel(group) }}</strong>
                </div>
                <div @click.stop>
                  <b-form-rating v-model="group.group_rating" stars="3" no-border variant="warning" disabled @input="syncGroupRating(group, $event)" />
                </div>
              </div>

              <div v-show="expandedSkillGroups[group.employee_skill_type_id]" class="p-2">
                <div v-if="!group.skills || group.skills.length === 0" class="text-muted">No skills found in this group.</div>
                <div v-for="skill in group.skills" :key="skill.employee_skill_id" class="row align-items-center mb-2">
                  <div class="col-12 col-md-5">
                    <b-form-checkbox v-model="skill.checked" @change="onSkillCheckedChange(group, skill)">
                      {{ skill.description }}
                    </b-form-checkbox>
                  </div>
                  <div class="col-12 col-md-4 mt-2 mt-md-0">
                    <input class="form-control" type="date" v-model="skill.checked_date" :disabled="!skill.checked" :max="todayDate()" />
                  </div>
                  <div class="col-12 col-md-3 mt-2 mt-md-0 text-muted small">
                    {{ formatSkillLastUpdatedMeta(skill.last_updated_by_name, skill.last_updated_at) }}
                  </div>
                </div>
              </div>
            </div>

            <b-button variant="primary" @click="updateSkills">Save Skills</b-button>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import CommonConstants from '@/constants/constants.js';
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'UserSkills',
  components: { Loading },
  data() {
    return {
      constants: CommonConstants,
      header: {},
      isLoading: true,
      profile: { skills: [], skill_group_ratings: [] },
      skillOptions: [],
      skilTypes: [],
      skillGroups: [],
      expandedSkillGroups: {},
      lastSelectedGroupRatings: {},
      deletedSkills: [],
      canEditMySkills: true,
    };
  },
  mounted() {
    this.header = {
      headers: {
        'Content-type': 'application/json',
        token: localStorage.getItem('token'),
      },
    };
    this.canEditMySkills = true;
    this.getLocations();
  },
  methods: {
    setMySkillEditAccess() {
      this.canEditMySkills = true;
    },
    todayDate() {
      return moment().format('YYYY-MM-DD');
    },
    normalizeRating(value) {
      return Math.max(0, Math.min(3, Math.round(Number(value) || 0)));
    },
    getSkillTypeId(item) {
      const raw = item && (item.employee_skill_type_id || item.skill_type_id || item.employee_skill_type || item.skill_type || item.employee_skill_types_id || item.skill_group_id || item.type_id);
      const id = Number(raw);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    getSkillId(item) {
      const raw = item && (item.employee_skill_id || item.skill_id || item.id);
      const id = Number(raw);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    resolveSkillGroupLabel(group) {
      const rawLabel = group && (group.type || group.type_name || group.group_name || group.label || group.value || group.name || group.description);
      const label = typeof rawLabel === 'string' ? rawLabel.trim() : '';
      if (label) return label;
      const groupId = Number(group && (group.employee_skill_type_id || group.id));
      return Number.isFinite(groupId) && groupId > 0 ? `Skill Group ${groupId}` : 'Skill Group';
    },
    formatSkillLastUpdatedMeta(name, ts) {
      if (!name && !ts) return '';
      return `Last Updated By ${name || 'Unknown'} - ${ts ? moment(ts).format('MMM DD, YYYY, h:mm A') : '-'}`;
    },
    toggleSkillGroup(groupId) {
      this.expandedSkillGroups = { ...this.expandedSkillGroups, [groupId]: !this.expandedSkillGroups[groupId] };
    },
    syncGroupRating(group, value) {
      const groupId = Number(group && group.employee_skill_type_id);
      const nextValue = this.normalizeRating(value);
      const previousValue = Object.prototype.hasOwnProperty.call(this.lastSelectedGroupRatings, groupId)
        ? this.lastSelectedGroupRatings[groupId]
        : this.normalizeRating(group.group_rating);
      const finalValue = previousValue === nextValue ? 0 : nextValue;
      group.group_rating = finalValue;
      this.lastSelectedGroupRatings = { ...this.lastSelectedGroupRatings, [groupId]: finalValue };
    },
    onSkillCheckedChange(group, skill) {
      if (!skill.checked) {
        if (skill.map_id) {
          this.deletedSkills.push({
            id: skill.map_id,
            employee_skill_id: skill.employee_skill_id,
            employee_skill_type_id: skill.employee_skill_type_id,
          });
        }
        skill.checked_date = '';
      }
    },
    getLocations() {
      this.isLoading = true;
      axios.get(this.constants.api_url + 'user/get-locations', this.header)
        .then((response) => {
          this.skillOptions = response.data.data.skills || [];
          this.skilTypes = response.data.data.skill_type || [];
          this.loadAllSkillOptions();
        })
        .catch((error) => {
          this.$toast.error(error.message || error, { position: 'top' });
          this.isLoading = false;
        });
    },
    loadAllSkillOptions() {
      const groupIds = (this.skilTypes || []).map((group) => this.getSkillTypeId(group)).filter((id) => Boolean(id));
      if (groupIds.length === 0) {
        this.getUserProfile();
        return;
      }
      axios.post(this.constants.api_url + 'user/get-skill-items/', { ids: groupIds }, this.header)
        .then((response) => {
          const fetchedSkills = (response.data && response.data.data && response.data.data.locations) || [];
          if (Array.isArray(fetchedSkills) && fetchedSkills.length > 0) {
            this.skillOptions = fetchedSkills;
          }
        })
        .finally(() => {
          this.getUserProfile();
        });
    },
    getUserProfile() {
      this.isLoading = true;
      this.profile.skills = [];
      axios.get(this.constants.api_url + 'users/skill/search/' + this.$route.params.id, this.header)
        .then((response) => {
          if (response.data.flag) {
            this.profile.skills = response.data.data || [];
            this.getUserSkillGroupRatings();
          } else {
            this.$toast.error(response.data.message, { position: 'top' });
            this.$router.push('/AccessControl');
          }
        })
        .catch((error) => {
          this.$toast.error(error.message || error, { position: 'top' });
          this.isLoading = false;
        })
    },
    getUserSkillGroupRatings() {
      axios.get(this.constants.api_url + 'user/edit/' + this.$route.params.id, this.header)
        .then((response) => {
          const userData = response && response.data && response.data.data && response.data.data.user && response.data.data.user[0]
            ? response.data.data.user[0]
            : null;
          this.profile.skill_group_ratings = userData && (userData.skill_group_ratings || userData.skillGroupRatings)
            ? (userData.skill_group_ratings || userData.skillGroupRatings)
            : [];
        })
        .catch(() => {
          this.profile.skill_group_ratings = [];
        })
        .finally(() => {
          this.buildSkillGroups();
          this.isLoading = false;
        });
    },
    buildSkillGroups() {
      const savedSkills = this.profile.skills || [];
      const savedGroupRatings = this.profile.skill_group_ratings || this.profile.skillGroupRatings || [];
      const groupRatingsByType = {};
      savedGroupRatings.forEach((groupRating) => {
        const typeId = this.getSkillTypeId(groupRating);
        if (!typeId) return;
        groupRatingsByType[typeId] = {
          rating: this.normalizeRating(groupRating.rating),
        };
      });
      const existingSkillsById = {};
      savedSkills.forEach((skill) => {
        const skillId = this.getSkillId(skill);
        if (skillId) existingSkillsById[skillId] = skill;
      });

      const groupDefs = {};
      (this.skilTypes || []).forEach((group) => {
        const groupId = this.getSkillTypeId(group);
        if (!groupId) return;
        groupDefs[groupId] = {
          employee_skill_type_id: groupId,
          type: group.type || group.type_name || group.group_name || group.label || group.value || group.name || group.description || group.title || `Skill Group ${groupId}`,
        };
      });

      savedSkills.forEach((skill) => {
        const groupId = this.getSkillTypeId(skill);
        if (!groupId) return;
        if (!groupDefs[groupId]) {
          groupDefs[groupId] = {
            employee_skill_type_id: groupId,
            type: skill.type || skill.group_name || skill.skill_type_name || `Skill Group ${groupId}`,
          };
        }
      });

      const expanded = {};
      this.skillGroups = Object.values(groupDefs).map((groupDef) => {
        const groupId = Number(groupDef.employee_skill_type_id);
        const skills = (this.skillOptions || [])
          .filter((skill) => this.getSkillTypeId(skill) === groupId)
          .map((skill) => {
            const skillId = this.getSkillId(skill);
            const saved = existingSkillsById[skillId];
            return {
              employee_skill_id: skillId,
              employee_skill_type_id: this.getSkillTypeId(skill) || groupId,
              map_id: saved ? (saved.id || saved.map_id || saved.employee_has_skill_id || null) : null,
              version_id: skill.version_id || null,
              description: skill.description || skill.value || skill.name,
              checked: Boolean(saved),
              checked_date: saved && saved.checked_date ? moment(saved.checked_date).format('YYYY-MM-DD') : (saved && saved.created_at ? moment(saved.created_at).format('YYYY-MM-DD') : ''),
              last_updated_by_name: saved ? (saved.last_updated_by_name || saved.updated_by_name || '') : '',
              last_updated_at: saved ? (saved.last_updated_at || saved.updated_at || saved.created_at || null) : null,
            };
          });

        const assignedSkills = savedSkills.filter((skill) => this.getSkillTypeId(skill) === groupId);
        let groupRating = 0;
        assignedSkills.forEach((saved) => {
          groupRating = Math.max(groupRating, this.normalizeRating(saved.rating));
        });
        if (Object.prototype.hasOwnProperty.call(groupRatingsByType, groupId)) {
          groupRating = groupRatingsByType[groupId].rating;
        }

        expanded[groupId] = Object.prototype.hasOwnProperty.call(this.expandedSkillGroups, groupId) ? this.expandedSkillGroups[groupId] : false;
        return {
          employee_skill_type_id: groupId,
          type: groupDef.type,
          group_rating: groupRating,
          skills,
        };
      });

      this.lastSelectedGroupRatings = this.skillGroups.reduce((acc, group) => {
        acc[group.employee_skill_type_id] = this.normalizeRating(group.group_rating);
        return acc;
      }, {});
      this.expandedSkillGroups = expanded;
    },
    updateSkills() {
      const locations = [];
      const skillGroupRatings = [];

      for (const group of this.skillGroups) {
        skillGroupRatings.push({
          employee_skill_type_id: group.employee_skill_type_id,
          rating: this.normalizeRating(group.group_rating),
        });

        for (const skill of group.skills) {
          if (!skill.checked) continue;
          if (!skill.checked_date) {
            this.$toast.error(`${skill.description} requires a checked date`, { position: 'top' });
            return;
          }
          if (moment(skill.checked_date).isAfter(moment(), 'day')) {
            this.$toast.error(`${skill.description} checked date cannot be in the future`, { position: 'top' });
            return;
          }
          locations.push({
            id: skill.map_id || null,
            map_id: skill.map_id || null,
            employee_skill_id: skill.employee_skill_id,
            employee_skill_type_id: skill.employee_skill_type_id,
            version_id: skill.version_id,
            rating: this.normalizeRating(group.group_rating),
            checked: 1,
            checked_date: moment(skill.checked_date).format('YYYY-MM-DD'),
          });
        }
      }

      this.isLoading = true;
      axios.post(this.constants.api_url + 'user/update-skill/' + this.$route.params.id, {
        skills: locations,
        skill_group_ratings: skillGroupRatings,
        flag: 'saved',
        deleted_items: this.deletedSkills,
      }, this.header)
        .then((response) => {
          if (response.data.flag) {
            this.deletedSkills = [];
            this.$toast.success('Skills Updated Successfully', { position: 'top' });
            this.getUserProfile();
          } else {
            this.$toast.error(response.data.message, { position: 'top' });
          }
        })
        .catch((error) => {
          this.$toast.error(error.message || error, { position: 'top' });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
/* Fix vue-toast-notification conflicting with Bootstrap .toast */
.notices.is-top {
  align-items: center !important;
  justify-content: flex-start !important;
  padding-top: 1em !important;
}
.notices .toast {
  flex-basis: auto !important;
  min-height: 3em !important;
}
.notices .toast .toast-text {
  word-break: normal !important;
  overflow-wrap: break-word;
}
</style>
